import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Navigation Icon
 *
 * @file Navigation.jsx
 * @author Nivedhitha M
 */
const Navigation = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 23 23" {...props}>
    <path
      fill="none"
      d="M12.1109 6.11145L21.6569 1.51525L17.0607 11.0612L11.7783
      21.3478C11.333 22.215 10.0367 21.9975 9.89883 21.0324L8.92893
      14.2432L2.13968 13.2733C1.17462 13.1354 0.957091 11.8391 1.82429
      11.3938L12.1109 6.11145Z"
      stroke="currentcolor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default Navigation;
